import React, { useState } from "react";
import Box from "@amzn/meridian/esm/components/box";
import Card from "@amzn/meridian/esm/components/card";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";

import ProductFeedback from "./feedback/ProductFeedback";
import { FEEDBACK_PAGE } from "./constants";
import feedbackIcon from "../../images/feedback_icon.svg";

const FeedbackCard = ({ page }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Card width="272px" onClick={() => setIsModalOpen(true)} spacingInset="none">
        <Row spacing="none">
          <Row width="16px" />
          <Column spacing="none" spacingInset="none">
            <Column height="20px" />
            <img src={feedbackIcon} alt="feedbackIcon" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
            <Column height="20px" />
          </Column>
          <Row width="16px" />
          <Box spacingInset="none" width="168px">
            <Column spacing="none" spacingInset="none">
              <Column height="16px" />
              <Text fontFamily="amazonEmber" type="h100" alignment="start">
                Feedback
              </Text>
              <Column height="8px" />
              <Text fontFamily="amazonEmber" type="b100" color="secondary" alignment="start">
                Like what you see?
              </Text>
              <Text fontFamily="amazonEmber" type="b100" color="secondary" alignment="start">
                Tell us about your experience
              </Text>
              <Column height="20px" />
            </Column>
          </Box>
        </Row>
      </Card>

      <ProductFeedback 
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        page={page}
      />
    </>
  );
};

export default FeedbackCard;
